// Shown only while the built-in sample agreement is in force.
const DefaultAgreementNotice = ({ className = "" }) => (
  <p
    className={`rounded-lg border border-warning-200 bg-warning-50 px-4 py-2.5 text-xs leading-relaxed text-warning-700 ${className}`}
  >
    This is a sample Vendor Agreement provided for reference purposes only. Its enforceability
    depends on applicable law and the specific circumstances of the parties.
  </p>
);

export default DefaultAgreementNotice;
